import {Link} from 'react-router-dom';
import {Navbar} from '@common/ui/navigation/navbar/navbar';
import {Footer} from '@common/ui/footer/footer';
import {useSettings} from '@common/core/settings/use-settings';
import {LaunchOfferBanner} from '@app/landing/launch-offer-banner';
import {PageSeo} from '@app/landing/page-seo';
import {currentYear} from '@app/landing/replace-year';
import {getAllAlternativeTools} from './alternative-page-data';
import '../landing-page.css';

export function AlternativesHubPage() {
  const {branding, base_url} = useSettings();
  const tools = getAllAlternativeTools();
  const siteName = branding?.site_name || 'LinkInBio';
  const pageUrl = `${(base_url || '').replace(/\/$/, '')}/alternatives`;

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PageSeo
        title={`Free Link in Bio Alternatives ${currentYear()} | LinkInBio.site`}
        description={`Compare ${siteName} to Linktree, Beacons, Stan Store and other link-in-bio tools — pricing, features, and honest pros and cons.`}
        url={pageUrl}
      />
      <Navbar
        color="bg"
        border="border-b"
        className="lp-sticky-nav"
        menuPosition="homepage-navbar"
      />

      <main className="flex-auto">
        <header className="pt-80 md:pt-100 pb-40">
          <div className="landing-container max-w-[1000px]">
            <LaunchOfferBanner className="mb-24 inline-block" />
            <span className="section-label">COMPARE</span>
            <h1 className="alt-heading mb-24">
              {branding?.site_name || 'LinkInBio'} vs. every other link-in-bio
              tool
            </h1>
            <p className="text-base text-muted max-w-[800px]">
              Honest, feature-by-feature comparisons — pricing, custom
              domains, link tracking, and what each tool does well — so you
              can pick the right bio-link tool for how you actually work.
            </p>
          </div>
        </header>

        <section className="pb-80 md:pb-100">
          <div className="landing-container max-w-[1000px]">
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-20">
              {tools.map(tool => (
                <Link
                  key={tool.slug}
                  to={`/alternatives/${tool.slug}`}
                  className="rounded-xl border p-24 hover:border-primary hover:bg-primary/5 transition-colors"
                >
                  <div className="text-xs font-bold uppercase tracking-wide text-primary mb-8">
                    Alternative
                  </div>
                  <h2 className="font-semibold text-lg mb-8">
                    {tool.toolName}
                  </h2>
                  <p className="text-sm text-muted line-clamp-3">
                    {tool.introParagraphs[0]}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="pb-80 md:pb-100">
          <div className="landing-container max-w-[1000px]">
            <div className="rounded-xl border bg-alt p-24 flex flex-wrap items-center justify-between gap-16">
              <div>
                <h2 className="font-semibold text-lg mb-4">
                  Looking for a guide built for your niche?
                </h2>
                <p className="text-sm text-muted">
                  See feature recommendations and tips for your specific
                  creator or business type.
                </p>
              </div>
              <Link
                to="/for"
                className="rounded-full border px-20 py-10 text-sm font-medium hover:bg-hover flex-shrink-0"
              >
                Browse use case guides
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer className="mx-14 md:mx-40" />
    </div>
  );
}
